import { request, unwrap } from '../client';
import type { ApiResponse, BrandAssetSlot, BrandAssetUploadResponse } from '../types';

const BASE = '/api/saas-admin/brands';

/**
 * SASADM-0156 — the brand image slots (saas-auth SASATH-0347, #962 §3.5).
 * 400 `SVG_REJECTED` / `ASSET_DIMENSIONS` / `ASSET_TYPE` carry a server message;
 * 413 is a file over 5 MB.
 */
export const brandAssetsApi = {
  async upload(
    brandId: number,
    slot: BrandAssetSlot,
    file: File,
  ): Promise<BrandAssetUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await request<ApiResponse<BrandAssetUploadResponse>>(
      'POST',
      `${BASE}/${brandId}/assets/${slot}`,
      { formData },
    );
    return unwrap(res);
  },

  async clear(brandId: number, slot: BrandAssetSlot): Promise<void> {
    await request<void>('DELETE', `${BASE}/${brandId}/assets/${slot}`);
  },
};
